<template>
  <div class="flex flex-centered mt-200">
    <icon-default
      icon="check"
      class="cancel_icon"
    />
  </div>
</template>

<script>
export default {
  name: "CancelIcon"
}
</script>

<style lang="scss" scoped>
@import "../../../../styles/variables/variables";

.cancel_icon {
  font-size: 6rem;
  color: $green;
}
</style>
